export default class ElementAllower {
    constructor(hideClassName) {
        this.hideClassName = hideClassName;
    }

    allowCategoryElements(categoryName) {
        const elementsToAllow = document.querySelectorAll(`[data-required-cookie="${categoryName}"]`);
        Array.prototype.slice.call(elementsToAllow).forEach((element) => {
            this.allowElement(element);
        });

        const elementsToHide = document.querySelectorAll(`[data-required-cookie-info="${categoryName}"]`);
        Array.prototype.slice.call(elementsToHide).forEach((element) => {
            element.classList.add(this.hideClassName);
        });
    }

    /**
     * Copies data-src to src and removes hide class
     * @param {HTMLElement} element
     */
    allowElement(element) {
        if (!element.hasAttribute("data-src")) {
            return;
        }
        const src = element.getAttribute("data-src");
        element.setAttribute("src", src);

        element.classList.remove(this.hideClassName);
    }

    init(eventDispatcher, cookieCategories) {
        Array.prototype.slice.call(cookieCategories).forEach((category) => {
            eventDispatcher.addAcceptListener(category.name,
                () => { this.allowCategoryElements(category.name); });
        });
    }
}
